import { slab, wallX, wallZ, goal, sign, neon, checkpoint, edgeLights } from '../kit.js';

/**
 * The momentum lesson. A 62 metre pit with a lit floor, and the only other
 * portalable surface is the wall behind you, aimed at nothing but open air.
 * Fall in, come out of the wall at terminal-ish speed, sail the gap.
 */
export default {
  id: 'freefall',
  name: 'FREEFALL',
  blurb: 'Speed in is speed out. Use the drop.',
  mode: { type: 'sprint', par: 18 },
  redline: { seconds: 15 },   // docs/REDLINE.md; seeded from the board, honesty pass pending
  spawn: { p: [0, 0.4, 5], yaw: 0 },
  killY: -190,
  env: {
    fog: 0x1a0824,
    fogDensity: 0.0042,
    sky: { zenith: 0x05030d, horizon: 0x2a0b2c, glow: 0x8a1a55, aurora: 0x0d5f80 },
    floorY: -320,
  },
  objects: [
    // ---- ledge you start on
    slab(0, 0, 0, 16, 18, 'plate', 1.4),
    ...edgeLights(0, 0, 0, 16, 18, 'cyan'),
    wallX(-8.7, 0, 0, 18, 7, 'plate', 1.4),
    wallX(8.7, 0, 0, 18, 7, 'plate', 1.4),

    // the only wall you can portal, and it points across the void
    wallZ(0, 0, 9.7, 22, 4, 'plate', 1.4),
    wallZ(0, 4, 9.7, 22, 14, 'panel', 1.4),
    neon(0, 18.2, 9.0, [22, 0.16, 0.16], 'cyan'),

    // ---- the pit. The near wall sits UNDER the ledge rather than between the
    // ledge and the opening: a 1.5m lip there would hide the pit floor from
    // anyone standing on the ledge, and the pit floor is the shot the level
    // is built around.
    wallZ(0, -62, -8.25, 27, 62, 'plate', 1.5),
    wallZ(0, -62, -33.75, 27, 48, 'plate', 1.5),     // stops short so the fling clears it
    wallX(-12.75, -62, -21, 24, 62, 'plate', 1.5),
    wallX(12.75, -62, -21, 24, 62, 'plate', 1.5),
    slab(0, -62, -21, 25.5, 24, 'panel', 1.5),       // portalable pit floor
    neon(0, -61.4, -21, [24, 0.16, 0.16], 'magenta'),
    neon(-11.9, -30, -21, [0.16, 60, 0.16], 'cyan'),
    neon(11.9, -30, -21, [0.16, 60, 0.16], 'cyan'),

    // ---- landing field, deliberately enormous
    slab(0, -64, -125, 64, 112, 'plate', 2),
    ...edgeLights(0, -64, -125, 64, 112, 'magenta'),
    wallZ(0, -64, -182.5, 66, 30, 'plate', 2),
    wallX(-33, -64, -125, 112, 14, 'plate', 2),
    wallX(33, -64, -125, 112, 14, 'plate', 2),
    neon(0, -50, -181.4, [60, 0.2, 0.2], 'magenta'),

    checkpoint(0, -64, -112),
    goal(0, -64, -140, 0),

    // ---- guidance
    sign(0, 3.6, -3, 0, [
      'FREEFALL',
      'THE PIT FLOOR TAKES A PORTAL',
      'SO DOES THE WALL BEHIND YOU',
    ]),
    sign(0, 6.0, 8.9, 0, ['EXIT VECTOR', 'FIRES INTO THE VOID'], '#2ff3ff'),
    sign(0, -58.5, -20.0, 0, ['62 METRES OF ACCELERATION'], '#ff2fd0'),
    sign(0, -60.0, -139, 0, ['EXTRACTION'], '#9dff3c'),
  ],
};
